import { border } from "@mui/system";
import React, { useState, useEffect } from "react";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";

const GooglePlaceField = (props) => {
  const [value, setValue] = useState(null);

  const handleOnchange = (e) => {
    props.handleChange(e);
    setValue(e);
  };


  useEffect(() => {
    // set location
    if (value) {
      props.handleChange(value?.label);
    }

    console.log(value?.label);
  }, [value]);

  console.log(props.error, 222);

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {props.label && (
          <div
            className="FieldLabel"
            style={{ fontSize: "14px", color: "#676c7b" }}
          >
            {props.label}
            {props.validation && <span style={{ color: "#d32f2f" }}>*</span>}
          </div>
        )}
        {props.error && props.HideRequireText && (
          <div style={{ fontSize: "12px", color: "#d32f2f" }}>Required</div>
        )}
      </div>
      <GooglePlacesAutocomplete
        apiKey={process.env.NEXT_PUBLIC_GOOGLE_PLACE_SITE_KEY}
        selectProps={{
          value: props.val,
          onChange: props.handleChange,
          placeholder: props.placeholder,
          styles: {
            input: (provided) => ({
              ...provided,
              // padding: "15.5px 14px",
              borderRadius: "8px",
              fontSize: "20px",
              borderColor: props.error ? "#d32f2f" : "#e4e8ec",
              "::placeholder": {
                color: "rgba(187, 191, 201, 1)",
              },
              "&:hover": {
                borderColor: props.error ? "#d32f2f" : "#e4e8ec",
              },
            }),
            control: (provided) => ({
              ...provided,
              padding: "10px 3px",
              borderRadius: "8px",
              fontSize: "20px",
              borderColor: props.error ? "#d32f2f" : "#e4e8ec",
              "&:hover": {
                borderColor: props.error ? "#d32f2f" : "#e4e8ec",
              },
            }),
            placeholder: (provided) => ({
              ...provided,
              color: "rgba(187, 191, 201, 1)",
            }),
            dropdownIndicator: (provided) => ({
              ...provided,
              display: "none",
            }),
            indicatorSeparator: (provided) => ({
              ...provided,
              display: "none",
            }),
          },
        }}
      />
      <div className="Address">
        {" "}
        {props.value && <span>{props.value}</span>}
      </div>
    </div>
  );
};

export default GooglePlaceField;
